module.exports = __webpack_public_path__ + "static/media/generic-white-small.41dc6369.svg";